import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';

const { Title, Text } = Typography;

const AdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onPasswordLogin = async (values) => {
    setLoading(true);
    try {
      const response = await authAPI.login(values.username, values.password);
      const { access_token, refresh_token } = response.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);
      localStorage.setItem('username', response.data.username || values.username);
      message.success('登录成功');
      navigate('/dashboard', { replace: true });
    } catch (error) {
      message.error(error.response?.data?.detail || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: '#0d1117'
    }}>
      <Card style={{ 
        width: 450, 
        boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
        background: '#161b22',
        border: '1px solid #30363d'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={2} style={{ 
            marginBottom: 8,
            color: '#58a6ff',
            fontWeight: 'bold'
          }}>管理员登录</Title>
          <Text style={{ color: '#8b949e' }}>XiaBO 管理后台</Text>
        </div>

        <Form
          name="admin_login"
          onFinish={onPasswordLogin}
          autoComplete="off"
          layout="vertical"
          style={{ marginTop: 24 }}
          className="dark-form"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input
              prefix={<UserOutlined style={{ color: '#8b949e' }} />}
              placeholder="用户名"
              size="large"
              className="dark-input"
              style={{ 
                height: 48,
                background: '#21262d !important',
                border: '1px solid #30363d !important',
                color: '#e6edf3 !important'
              }}
              styles={{
                input: {
                  color: '#e6edf3 !important',
                  '::placeholder': {
                    color: '#ffffff !important',
                    opacity: 1
                  }
                }
              }}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: '#8b949e' }} />}
              placeholder="密码"
              size="large"
              className="dark-input"
              style={{ 
                height: 48,
                background: '#21262d !important',
                border: '1px solid #30363d !important',
                color: '#e6edf3 !important'
              }}
              styles={{
                input: {
                  color: '#e6edf3 !important',
                  '::placeholder': {
                    color: '#ffffff !important',
                    opacity: 1
                  }
                }
              }}
            />
          </Form.Item>

          <Form.Item style={{ marginTop: 32 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              size="large"
              block
              style={{ 
                height: 48,
                background: '#238636',
                border: '1px solid #238636'
              }}
            >
              登录
            </Button>
          </Form.Item>

          <Form.Item style={{ textAlign: 'center', marginTop: 16 }}>
            <Text style={{ fontSize: 12, color: '#8b949e' }}>
              普通用户请访问 <a href="/login" style={{ color: '#58a6ff' }}>激活码登录</a>
            </Text>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AdminLogin;
